import React, { useState } from 'react';
import { supabase } from '../../lib/supabase';
import { saveStudentSession, acBase, Spinner } from './academyUtils';
import { hashPassword, validateEmail } from '../../utils/auth';
import { useLanguage } from '../../context/LanguageContext';

export default function StudentLogin({ onSuccess, onRegister, onBack, onForgotPassword }) {
  const { t } = useLanguage();
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');

  async function handleLogin() {
    setError('');
    if (!validateEmail(email)) { setError(t('invalidEmail')); return; }
    if (!password) { setError('Please enter your password.'); return; }

    setLoading(true);
    try {
      const hash = await hashPassword(password);
      const { data, error: err } = await supabase
        .from('students')
        .select('*')
        .eq('email', email.trim().toLowerCase())
        .eq('password_hash', hash)
        .single();

      if (err || !data) {
        // Distinguish wrong password vs not found
        const { data: exists } = await supabase
          .from('students').select('id').eq('email', email.trim().toLowerCase()).maybeSingle();
        setError(exists ? t('loginFailed') : 'Email not found. Please register first.');
      } else if (!data.active) {
        setError('Your account has not been activated yet. Contact Mr. Ahmed Salem on WhatsApp.');
      } else {
        saveStudentSession(data);
        onSuccess(data);
      }
    } catch {
      setError(t('connectionError'));
    } finally { setLoading(false); }
  }

  return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(135deg,#f0f4f8,#e4ecf7)', display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div style={{ width:'100%', maxWidth:400 }}>
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <img src="/logo.png" alt="IELTS Compass" style={{ height:56, objectFit:'contain', marginBottom:10 }}/>
          <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:20, fontWeight:700, color:'#1a2a4a', lineHeight:1.1 }}>
            IELTS<span style={{ color:'#b8860b' }}>COMPASS</span>
          </div>
          <div style={{ fontSize:11, color:'#5a6a88', fontFamily:"'JetBrains Mono',monospace", letterSpacing:'.14em', textTransform:'uppercase', marginTop:4 }}>Student Portal</div>
        </div>

        <div style={acBase.card}>
          <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:22, fontWeight:700, color:'#1a2a4a', marginBottom:4 }}>Student Login</div>
          <div style={{ fontSize:13, color:'#5a6a88', marginBottom:20, lineHeight:1.6 }}>Enter your email and password to access your dashboard.</div>

          <label style={acBase.lbl}>{t('emailAddress')}</label>
          <input type="email" value={email} onChange={e=>setEmail(e.target.value)}
            placeholder="yourname@email.com" style={acBase.inp} autoFocus/>

          <label style={acBase.lbl}>Password</label>
          <input type="password" value={password} onChange={e=>setPassword(e.target.value)}
            onKeyDown={e=>e.key==='Enter'&&handleLogin()} placeholder="••••••••" style={acBase.inp}/>

          <div style={{ textAlign:'right', marginBottom:10, marginTop:-8 }}>
            <button onClick={() => onForgotPassword && onForgotPassword()}
              style={{ background:'none', border:'none', color:'#1a5fa8', fontSize:12, cursor:'pointer', fontFamily:"'Plus Jakarta Sans',sans-serif", padding:0, textDecoration:'underline' }}>
              {t('forgotPassword')}
            </button>
          </div>

          {error && <div style={acBase.err}>{error}</div>}

          <button onClick={handleLogin} disabled={loading}
            style={{ ...acBase.btn, opacity:loading?0.7:1, display:'flex', alignItems:'center', justifyContent:'center', gap:8, marginBottom:14 }}>
            {loading ? <Spinner/> : 'Access My Dashboard →'}
          </button>

          <div style={{ textAlign:'center', fontSize:13, color:'#5a6a88' }}>
            New student?{' '}
            <button onClick={onRegister} style={{ background:'none', border:'none', color:'#b8860b', cursor:'pointer', fontSize:13, fontWeight:600, textDecoration:'underline', padding:0 }}>
              Register here
            </button>
          </div>
          <div style={{ textAlign:'center', marginTop:12 }}>
            <button onClick={onBack} style={acBase.back}>← Back</button>
          </div>
        </div>
      </div>
    </div>
  );
}
